(function() {
    function funcReady() {
        // KRP0015 다른 영역 클릭 시 (compare관련 storage 상태 변화가 없을 경우) 레이어 닫힘
        var $targetSticy =  $('.sticy-compare');
        var checkCompareClick = false;
        $('.wrap, .iw_viewport-wrapper').off('click.KRP0015').on('click.KRP0015', function(e){
            // BTOCSITE-30428 : PDP 이벤트 이중 발생
            if(checkCompareClick) {
                return;
            }
            checkCompareClick = true;

            if($(e.target).parents('.KRP0015').length < 1 && $(e.target).text() !== '비교하기') {
                var isOpen = $targetSticy.find('.right-cont .more-arrow').hasClass('close');
                if (!isOpen && $('.KRP0015').css('display') == 'block') {
                    $targetSticy.removeClass('is-active');
                    $('.KRP0015').removeClass('is-active');
                    $targetSticy.find('.right-cont .more-arrow').removeClass('open').addClass('close');
                    $targetSticy.find('.right-cont .more-arrow').attr('aira-expanded', false);
                    $targetSticy.find('.right-cont .more-arrow span.blind').text('제품 비교하기 펼치기');

                    var height = $('.KRP0015').outerHeight(true) - $targetSticy.find('.compare-title').outerHeight(true);
                    $('.KRP0015').stop().transition({y: height}, 200, "easeInOutCubic");
                    $('body').addClass('open-compare');
                }
            }

            setTimeout(function(){
                checkCompareClick = false;
            }, 500);
        });

        // 통합검색에서 카테고리가 여러개일 수 있고 lgkorUI.getHiddenInputData().categoryId로 적용 불가 하여 추가
        var searchCategoryId = Object.keys(lgkorUI.getStorage(lgkorUI.COMPARE_KEY))[0] || null;

        $('.wrap').on('click', '.search .compare_check', function(){
            var data = $(this).closest('li').find('.item').data('ecProduct');
            searchCategoryId = data.category_id;
        })

        $('.KRP0015').buildCommonUI();
        ;(function ($, _$) {
            var compareSelect =
                '<div class="select-wrap">' +
                '<select class="ui_selectbox" id="compareSelect" name="compareSelect" title="비교하기 카테고리 선택">' +
                '{{#each item in list}}' +
                '<option value="{{item.value}}" {{item.selected}}>{{item.label}} ({{item.count}}/3)</option> ' +
                '{{/each}}' +
                '</select>' +
                '</div>';

            var similar =
                '<a href="{{url}}" class="similar-list">' +
                '<p>옆에 담은 제품과 <br class="mo-only">같은<br class="pc-only"> 카테고리 제품 <br class="mo-only">리스트 보기</p>' +
                '</a>';
            var compare =
                '<button class="similar-list compare-close">' +
                '<p>옆에 담은 제품과 <br class="mo-only">같은<br class="pc-only"> 카테고리 제품 <br class="mo-only">리스트 보기</p>' +
                '</button>';

            var searchMessage =
                '<div class="similar-list only-text">' +
                '<p>비교하고 싶은 제품을<br>추가로 선택해주세요.</p>' +
                '</div>';
            var wishMessage =
                '<div class="similar-list only-text">' +
                '<p>위시리스트에서<br>선택하기</p>' +
                '</div>';

            var itemTemplate =
                '<a href="{{path}}" class="item-inner" data-id="{{id}}" data-category-id="{{categoryId}}" data-b2bcatemapping="{{b2bcatemapping}}">' +
                '   <span class="img-area">' +
                '       <img src="{{productImg}}" alt="{{productAlt}}">' +
                '       <p class="blind">{{productAlt}}</p>' +
                '   </span>' +
                '   <div class="item-text">' +
                '       <p class="product-name">{{#raw productName}}</p>' +
                '       <p class="model-name">{{productID}}</p>' +
                '   </div>' +
                '</a>' +
                '<button type="button" class="btn-close"><span class="blind">제품 비교하기에서 제거</span></button>';

            var isInitChecked = false;

            var compareIds = "";
            var compareCategoryIds = "";

            var isFirstOpen = true;

            function init() {
                self.willRemoveForCompare = false;

                //초기화
                $('.btn-init').on('click', function (e) {
                    setClearCompare();
                });

                //결과보기 버튼
                $('.btn-compare').on('click', function (e) {
                    e.preventDefault();

                    var $uiSelectbox = $('.sticy-compare .ui_selectbox');
                    var categoryId;

                    if($uiSelectbox.length) {
                        categoryId = $uiSelectbox.vcSelectbox('value');
                    } else {
                        // BTOCSITE-38770
                        categoryId = Object.keys(lgkorUI.getStorage(lgkorUI.COMPARE_KEY))[0];
                    }

                    var compareIDs = [];
                    var compareStorage = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, categoryId);
                    compareStorage['data'].forEach(function(item){ compareIDs.push(item.id + '|' + item.careType); });
                    var compareCookie = {};
                    compareCookie[categoryId] = compareIDs.join(",");

                    lgkorUI.setCookie("LG5_CompareCart_Selected", JSON.stringify(compareCookie));

                    var prodCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY); //BTOCSITE-48266
                    //var prodCompare = {"CT50000025":{"categoryName":"TV","data":[{"id":"MD08979866","b2bcatemapping":"N","productName":"LG 스탠바이미","productID":"27ART10AKPL","productImg":"/kr/images/tvs/md08979866/md08979866-350x350.jpg","productAlt":"TV LG 스탠바이미 (27ART10AKPL.AKR) 썸네일","careType":"R"},{"id":"MD09062827","b2bcatemapping":"N","productName":"LG 올레드 evo 오브제컬렉션 ","productID":"65ART90EKPA","productImg":"/kr/images/tvs/md09062827/md09062827-350x350.jpg","productAlt":"TV LG 올레드 evo 오브제컬렉션  (65ART90EKPA.AKR) 썸네일","careType":"R"},{"id":"MD09086828","b2bcatemapping":"N","productName":"LG 올레드 evo 오브제컬렉션","productID":"65ART90EKPC","productImg":"/kr/images/tvs/md09086828/md09086828-350x350.jpg","productAlt":"TV LG 올레드 evo 오브제컬렉션 (65ART90EKPC.AKR) 썸네일","careType":"R"}]},"CT50000036":{"categoryName":"AV","data":[{"id":"MD09113830","b2bcatemapping":"N","productName":"LG 울트라기어 게이밍스피커","productID":"GP3","productImg":"/kr/images/home-audio/md09113830/md09113830-350x350.jpg","productAlt":"AV LG 울트라기어 게이밍스피커 (GP3.AKOR) 썸네일","careType":"R"},{"id":"MD09112827","b2bcatemapping":"N","productName":"LG TONE+","productID":"TONE-TNP3","productImg":"/kr/images/home-audio/md09112827/md09112827-350x350.jpg","productAlt":"AV LG TONE+ (TONE-TNP3.AKOR) 썸네일","careType":"R"}]},"CT50077000":{"categoryName":"상업용 디스플레이","data":[{"id":"MD09125834","b2bcatemapping":"N","productName":"LG LED All-in-One 스마트 시리즈","productID":"LAEC","productImg":"/kr/images/displays/md09125834/md09125834-350x350.jpg","productAlt":"상업용 디스플레이 LG LED All-in-One 스마트 시리즈 (LAEC015-GN.AKR) 썸네일","careType":"R"},{"id":"MD09112831","b2bcatemapping":"N","productName":"LG 디지털 사이니지 Video Wall","productID":"55VSH7J","productImg":"/kr/images/displays/md09112831/md09112831-350x350.jpg","productAlt":"상업용 디스플레이 LG 디지털 사이니지 Video Wall (55VSH7J-H.AKRD) 썸네일","careType":"R"},{"id":"MD09112832","b2bcatemapping":"N","productName":"LG 디지털 사이니지 Video Wall","productID":"55VSM5J","productImg":"/kr/images/displays/md09112832/md09112832-350x350.jpg","productAlt":"상업용 디스플레이 LG 디지털 사이니지 Video Wall (55VSM5J-H.AKRD) 썸네일","careType":"R"}]}};
                    var prodCompareResult = {};

                    for(key in prodCompare){
                        var inner = prodCompare[key].data;
                        if(prodCompare[key].data.length > 1) {
                            prodCompareResult[key] = "";
                            for (key2 in inner) {
                                var comma = key2 < inner.length - 1 ? ',' : '';
                                prodCompareResult[key] += inner[key2].id + '|' + inner[key2].careType + comma
                            }
                        }
                    }

                    lgkorUI.setCookie("LG5_CompareCart_All", JSON.stringify(prodCompareResult));

                    //비교하기 비우기
                    //2021-03-16
                    self.willRemoveForCompare = true;
                    hideCompareBox();
                    lgkorUI.removeCompareProd(categoryId);

                    var url = $(this).data('url');
                    if (url) {
                        if(location.pathname.indexOf(lgkorUI.B2B_PATH_URL + "/") > -1) {  //BTOCSITE-48266
                            url = lgkorUI.B2B_PATH_URL + url;
                        }
                        location.href = url;
                    }
                });

                $('.sticy-compare .list-inner li').on('click', '.btn-close', function (e) {
                    e.preventDefault();
                    var $uiSelectbox = $('.sticy-compare .ui_selectbox');
                    var id = $(this).siblings('.item-inner').data("id");
                    var itemCategoryId = $(this).siblings('.item-inner').data("categoryId");
                    var categoryId;

                    if($uiSelectbox.length) {
                        categoryId = $uiSelectbox.vcSelectbox('value');
                    } else {
                        // BTOCSITE-38770
                        if(itemCategoryId && itemCategoryId != '') {
                            categoryId = itemCategoryId;
                        } else {
                            categoryId = lgkorUI.getHiddenInputData().categoryId;
                        }
                    }

                    lgkorUI.removeCompareProd(categoryId, id);
                    //BTOCSITE-48266
                    if($('.sticy-compare .list-inner li').hasClass("lge-only")){
                        $('.sticy-compare .list-inner li').removeClass("lge-only");
                    }
                });

                $('.right-cont .more-arrow').on('click', function (e) {
                    e.preventDefault();
                    if ($(this).hasClass('close')) openCompareBox();
                    else closeCompareBox();
                });

                $('.sticy-compare .compare-list').on('click', '.similar-list', function (e) {
                    lgkorUI.setStorage('come-from-pdp', true);
                });

                var compareCate = lgkorUI.getStorage(lgkorUI.COMPARE_KEY);
                //var compareCate = {"CT50000025":{"categoryName":"TV","data":[{"id":"MD08979866","b2bcatemapping":"N","productName":"LG 스탠바이미","productID":"27ART10AKPL","productImg":"/kr/images/tvs/md08979866/md08979866-350x350.jpg","productAlt":"TV LG 스탠바이미 (27ART10AKPL.AKR) 썸네일","careType":"R"},{"id":"MD09062827","b2bcatemapping":"N","productName":"LG 올레드 evo 오브제컬렉션 ","productID":"65ART90EKPA","productImg":"/kr/images/tvs/md09062827/md09062827-350x350.jpg","productAlt":"TV LG 올레드 evo 오브제컬렉션  (65ART90EKPA.AKR) 썸네일","careType":"R"},{"id":"MD09086828","b2bcatemapping":"N","productName":"LG 올레드 evo 오브제컬렉션","productID":"65ART90EKPC","productImg":"/kr/images/tvs/md09086828/md09086828-350x350.jpg","productAlt":"TV LG 올레드 evo 오브제컬렉션 (65ART90EKPC.AKR) 썸네일","careType":"R"}]},"CT50000036":{"categoryName":"AV","data":[{"id":"MD09113830","b2bcatemapping":"N","productName":"LG 울트라기어 게이밍스피커","productID":"GP3","productImg":"/kr/images/home-audio/md09113830/md09113830-350x350.jpg","productAlt":"AV LG 울트라기어 게이밍스피커 (GP3.AKOR) 썸네일","careType":"R"},{"id":"MD09112827","b2bcatemapping":"N","productName":"LG TONE+","productID":"TONE-TNP3","productImg":"/kr/images/home-audio/md09112827/md09112827-350x350.jpg","productAlt":"AV LG TONE+ (TONE-TNP3.AKOR) 썸네일","careType":"R"}]},"CT50077000":{"categoryName":"상업용 디스플레이","data":[{"id":"MD09125834","b2bcatemapping":"N","productName":"LG LED All-in-One 스마트 시리즈","productID":"LAEC","productImg":"/kr/images/displays/md09125834/md09125834-350x350.jpg","productAlt":"상업용 디스플레이 LG LED All-in-One 스마트 시리즈 (LAEC015-GN.AKR) 썸네일","careType":"R"},{"id":"MD09112831","b2bcatemapping":"N","productName":"LG 디지털 사이니지 Video Wall","productID":"55VSH7J","productImg":"/kr/images/displays/md09112831/md09112831-350x350.jpg","productAlt":"상업용 디스플레이 LG 디지털 사이니지 Video Wall (55VSH7J-H.AKRD) 썸네일","careType":"R"},{"id":"MD09112832","b2bcatemapping":"N","productName":"LG 디지털 사이니지 Video Wall","productID":"55VSM5J","productImg":"/kr/images/displays/md09112832/md09112832-350x350.jpg","productAlt":"상업용 디스플레이 LG 디지털 사이니지 Video Wall (55VSM5J-H.AKRD) 썸네일","careType":"R"}]}};

                // 세션스토리지에 이전 데이터 형식이면 초기화 한다.
                for (var i in compareCate) {
                    if (vcui.isArray(compareCate[i]) || !compareCate[i].categoryName) {
                        lgkorUI.removeStorage(lgkorUI.COMPARE_KEY);
                        break;
                    }
                }

                if(lgkorUI.getHiddenInputData().categoryId || searchCategoryId) {
                    setCompares();
                    setCompareStatus(null, true);
                }

                // 통합검색 최초 노출 처리
                _$(document).ajaxComplete(function(event, request, setting){
                    if(setting.url.indexOf('/search/allVIO16.lgajax') !== -1) {
                        var searchProductData = request.responseJSON.data.product.data;
                        var isCompareCategory = 0;
                        var categoryList = [];

                        searchProductData.forEach(function (item) {
                            var targetId = item.categoryId;
                            if(targetId && lgkorUI.getStorage(lgkorUI.COMPARE_KEY, targetId)) {
                                isCompareCategory++;
                                categoryList.push(targetId);
                            }
                        })


                        if(searchProductData && isCompareCategory) {
                            setCompares(categoryList[0]);
                            setCompareStatus(categoryList[0], true);
                        }

                    }
                });

                _$(window).on("changeStorageData", function (e) {
                    if(e.key == lgkorUI.COMPARE_KEY) { //BTOCSITE-48266
                        setTimeout(function(){
                            setCompares(e.name || null);
                            setCompareStatus(e.name || null);
                        }, 300);
                    }
                }).on("excessiveCompareStorage", function (e) {
                    if("PLP" === lgkorUI.getHiddenInputData().pageGupun) {
                        showCompareBox(e.name || null);
                    }
                    addToastAlert('excessive');
                    updateCompareButton();
                }).on("showCompareBox", function (e) {
                    showCompareBox(e.name || null);
                });

                _$(window).on('load', function(){
                    if(lgkorUI.getStorage('come-from-pdp') == true) {
                        _$(window).trigger("toastshow", "새로운 제품을 담아주세요.");
                        lgkorUI.removeStorage('come-from-pdp');
                    }
                });
            }

            function setCompares(id) {
                var categoryId;

                if (id) {
                    categoryId = id
                } else {
                    if("PDP" === lgkorUI.getHiddenInputData().pageGupun) {
                        categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
                    } else if(lgkorUI.getHiddenInputData().categoryId) {
                        categoryId = lgkorUI.getHiddenInputData().categoryId;
                    } else {
                        categoryId = searchCategoryId;
                    }
                }

                var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, categoryId);
                var isCompare = vcui.isEmpty(storageCompare);
                var compareCate = lgkorUI.getStorage(lgkorUI.COMPARE_KEY);
                //var compareCate = {"CT50000025":{"categoryName":"TV","data":[{"id":"MD08979866","b2bcatemapping":"N","productName":"LG 스탠바이미","productID":"27ART10AKPL","productImg":"/kr/images/tvs/md08979866/md08979866-350x350.jpg","productAlt":"TV LG 스탠바이미 (27ART10AKPL.AKR) 썸네일","careType":"R"},{"id":"MD09062827","b2bcatemapping":"N","productName":"LG 올레드 evo 오브제컬렉션 ","productID":"65ART90EKPA","productImg":"/kr/images/tvs/md09062827/md09062827-350x350.jpg","productAlt":"TV LG 올레드 evo 오브제컬렉션  (65ART90EKPA.AKR) 썸네일","careType":"R"},{"id":"MD09086828","b2bcatemapping":"N","productName":"LG 올레드 evo 오브제컬렉션","productID":"65ART90EKPC","productImg":"/kr/images/tvs/md09086828/md09086828-350x350.jpg","productAlt":"TV LG 올레드 evo 오브제컬렉션 (65ART90EKPC.AKR) 썸네일","careType":"R"}]},"CT50000036":{"categoryName":"AV","data":[{"id":"MD09113830","b2bcatemapping":"N","productName":"LG 울트라기어 게이밍스피커","productID":"GP3","productImg":"/kr/images/home-audio/md09113830/md09113830-350x350.jpg","productAlt":"AV LG 울트라기어 게이밍스피커 (GP3.AKOR) 썸네일","careType":"R"},{"id":"MD09112827","b2bcatemapping":"N","productName":"LG TONE+","productID":"TONE-TNP3","productImg":"/kr/images/home-audio/md09112827/md09112827-350x350.jpg","productAlt":"AV LG TONE+ (TONE-TNP3.AKOR) 썸네일","careType":"R"}]},"CT50077000":{"categoryName":"상업용 디스플레이","data":[{"id":"MD09125834","b2bcatemapping":"N","productName":"LG LED All-in-One 스마트 시리즈","productID":"LAEC","productImg":"/kr/images/displays/md09125834/md09125834-350x350.jpg","productAlt":"상업용 디스플레이 LG LED All-in-One 스마트 시리즈 (LAEC015-GN.AKR) 썸네일","careType":"R"},{"id":"MD09112831","b2bcatemapping":"N","productName":"LG 디지털 사이니지 Video Wall","productID":"55VSH7J","productImg":"/kr/images/displays/md09112831/md09112831-350x350.jpg","productAlt":"상업용 디스플레이 LG 디지털 사이니지 Video Wall (55VSH7J-H.AKRD) 썸네일","careType":"R"},{"id":"MD09112832","b2bcatemapping":"N","productName":"LG 디지털 사이니지 Video Wall","productID":"55VSM5J","productImg":"/kr/images/displays/md09112832/md09112832-350x350.jpg","productAlt":"상업용 디스플레이 LG 디지털 사이니지 Video Wall (55VSM5J-H.AKRD) 썸네일","careType":"R"}]}};

                // 카테고리가 1개이상이면 selectbox 붙힌다
                if (Object.keys(compareCate).length > 1) {
                    var selectData = {
                        'list': []
                    }
                    Object.keys(compareCate).map(function (key) {
                        var selected = '';
                        if (categoryId == key) selected = 'selected';

                        selectData['list'].push({
                            'label': compareCate[key].categoryName,
                            'value': key,
                            'selected': selected,
                            'count': compareCate[key].data.length
                        });
                    });

                    if ($('.sticy-compare .select-wrap').length > 0) {
                        $('.sticy-compare .select-wrap').remove();
                    }

                    $('.sticy-compare .compare-title').append(vcui.template(compareSelect, selectData))

                    selectBoxTotalCount();
                    window.addEventListener('resize', selectBoxTotalCount);

                    $('.sticy-compare .ui_selectbox').vcSelectbox().on('change', function () {
                        var categoryId = $(this).val();
                        setCompares(categoryId);
                        setCompareStatus(categoryId);
                    })
                }

                if (!isCompare) {
                    if (!vcui.isEmpty(storageCompare)) {
                        var ids = vcui.array.map(storageCompare['data'], function (item) {
                            return item.id;
                        }).join('|');

                        // BTOCSITE-62469 [선감지][모니터링 G] PLP 화면에서 비교하기 선택 시 닷컴ONLY 뱃지 미노출 되는 현상 START
                        if (storageCompare.data.length === 1) {
                            compareIds = "";
                        }
                        // BTOCSITE-62469 [선감지][모니터링 G] PLP 화면에서 비교하기 선택 시 닷컴ONLY 뱃지 미노출 되는 현상 END

                        if (compareIds != ids || compareCategoryIds != categoryId) {
                            compareIds = ids;
                            compareCategoryIds = categoryId; 

                            $('.sticy-compare .list-inner li').empty();

                            var ajaxUrl = document.querySelector('[data-spec-compare-url]') ? document.querySelector('[data-spec-compare-url]').dataset.specCompareUrl : "/mkt/api/product/retrieveProductCategoryUrl.lgajax";
                            //var ajaxUrl = "/mkt/api/product/retrieveProductCategoryUrl.lgajax"
                            var prodCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY); // BTOCSITE-48266
                            //var prodCompare = {"CT50000025":{"categoryName":"TV","data":[{"id":"MD08979866","b2bcatemapping":"N","productName":"LG 스탠바이미","productID":"27ART10AKPL","productImg":"/kr/images/tvs/md08979866/md08979866-350x350.jpg","productAlt":"TV LG 스탠바이미 (27ART10AKPL.AKR) 썸네일","careType":"R"},{"id":"MD09062827","b2bcatemapping":"N","productName":"LG 올레드 evo 오브제컬렉션 ","productID":"65ART90EKPA","productImg":"/kr/images/tvs/md09062827/md09062827-350x350.jpg","productAlt":"TV LG 올레드 evo 오브제컬렉션  (65ART90EKPA.AKR) 썸네일","careType":"R"},{"id":"MD09086828","b2bcatemapping":"N","productName":"LG 올레드 evo 오브제컬렉션","productID":"65ART90EKPC","productImg":"/kr/images/tvs/md09086828/md09086828-350x350.jpg","productAlt":"TV LG 올레드 evo 오브제컬렉션 (65ART90EKPC.AKR) 썸네일","careType":"R"}]},"CT50000036":{"categoryName":"AV","data":[{"id":"MD09113830","b2bcatemapping":"N","productName":"LG 울트라기어 게이밍스피커","productID":"GP3","productImg":"/kr/images/home-audio/md09113830/md09113830-350x350.jpg","productAlt":"AV LG 울트라기어 게이밍스피커 (GP3.AKOR) 썸네일","careType":"R"},{"id":"MD09112827","b2bcatemapping":"N","productName":"LG TONE+","productID":"TONE-TNP3","productImg":"/kr/images/home-audio/md09112827/md09112827-350x350.jpg","productAlt":"AV LG TONE+ (TONE-TNP3.AKOR) 썸네일","careType":"R"}]},"CT50077000":{"categoryName":"상업용 디스플레이","data":[{"id":"MD09125834","b2bcatemapping":"N","productName":"LG LED All-in-One 스마트 시리즈","productID":"LAEC","productImg":"/kr/images/displays/md09125834/md09125834-350x350.jpg","productAlt":"상업용 디스플레이 LG LED All-in-One 스마트 시리즈 (LAEC015-GN.AKR) 썸네일","careType":"R"},{"id":"MD09112831","b2bcatemapping":"N","productName":"LG 디지털 사이니지 Video Wall","productID":"55VSH7J","productImg":"/kr/images/displays/md09112831/md09112831-350x350.jpg","productAlt":"상업용 디스플레이 LG 디지털 사이니지 Video Wall (55VSH7J-H.AKRD) 썸네일","careType":"R"},{"id":"MD09112832","b2bcatemapping":"N","productName":"LG 디지털 사이니지 Video Wall","productID":"55VSM5J","productImg":"/kr/images/displays/md09112832/md09112832-350x350.jpg","productAlt":"상업용 디스플레이 LG 디지털 사이니지 Video Wall (55VSM5J-H.AKRD) 썸네일","careType":"R"}]}};
                            var prodCompareResult = "";
                            var idx = 0;

                            for(key in prodCompare){
                                idx++;
                                var comma =  idx < Object.keys(prodCompare).length ? ',' : '';
                                prodCompareResult += key + comma;
                            }

                            lgkorUI.requestAjaxDataPost(ajaxUrl, {"categoryId" : prodCompareResult},function(result) {
                                var resultData = result.data;
                                var relativeCategoryUrl;

                                storageCompare['data'].forEach(function (item, i) {
                                    list = $('.sticy-compare .list-inner li').eq(i);
                                    if(i == 0){
                                        //닷컴온니 뱃지 초기화
                                        list.removeClass("lge-only");
                                        $('.sticy-compare .list-inner li').eq(1).removeClass("lge-only");
                                        $('.sticy-compare .list-inner li').eq(2).removeClass("lge-only");
                                    }
                                    //BTOCSITE-48266 : b2c 일때만 닷컴온리 뱃지 노출
                                    /*if(item.b2cYN ==="Y"){
                                        if(item.lgecomOnlyFlag === "Y"){
                                            list.addClass("lge-only");
                                        }else{
                                            list.removeClass("lge-only");
                                        }
                                    }*/
                                    if(item.lgecomOnlyFlag === "Y"){
                                        list.addClass("lge-only");
                                    }else{
                                        list.removeClass("lge-only");
                                    }

                                    item.categoryId = categoryId;
                                    listItem = vcui.template(itemTemplate, item);
                                    list.html(listItem);
                                    list.closest('.list-inner').data('categoryId', categoryId);

                                    resultData.forEach(function(data){
                                        if(categoryId == data.categoryId){
                                            relativeCategoryUrl = lgkorUI.DEFAULT_URL + data.categoryUrlPath;
                                            return false;
                                        }
                                    })


                                    list.siblings("li").each(function(){
                                        if($(this).find('.item-inner').length == 0){
                                            if(document.querySelector('.KRP0007')) {
                                                var plpCategoryId = lgkorUI.getHiddenInputData().categoryId;
                                                if(categoryId == plpCategoryId){
                                                    $(this).html(compare);
                                                } else {
                                                    $(this).html(vcui.template(similar, {"url": relativeCategoryUrl}));
                                                }
                                            } else if(location.search.indexOf('?search=') > -1){
                                                $(this).html(vcui.template(searchMessage, {"url": relativeCategoryUrl}));
                                            } else if(document.querySelector('.o4o-store')){
                                                $(this).html(wishMessage); // BTOCSITE-17603
                                            } else {
                                                $(this).html(vcui.template(similar, {"url": relativeCategoryUrl}));
                                            }
                                        }
                                    })
                                });

                                updateCompareButton();
                                updateCompareItemHeight(); /* BTOCSITE-76675 비교하기 UI/UX 개선 */

                                $('.compare-close').on('click', function () {
                                    closeCompareBox();
                                    _$(window).trigger("toastshow", "새로운 제품을 담아주세요.");
                                })

                            });
                        }
                    }
                }
                /* [S] BTOCSITE-76675 비교하기 UI/UX 개선 */
                var leng = isCompare ? "0" : storageCompare.data.length;
                var $count = $('div.compare-title div.count');
                var countText = '<span class="blind">선택된 제품개수</span>'+ leng +'/<span class="blind">제품비교가능한 전체개수</span>3'
                $count.html(countText);
                /* [E] BTOCSITE-76675 비교하기 UI/UX 개선 */
                if(Object.keys(compareCate).length > 1) {
                    $count.hide();
                } else {
                    $count.show();
                }
            }

            function setCompareStatus(id, load) {
                var $uiSelectbox = $('.sticy-compare .ui_selectbox');
                var getCompareStorageKeys = Object.keys(lgkorUI.getStorage(lgkorUI.COMPARE_KEY));
                var categoryId;

                if (id) {
                    categoryId = id
                } else {
                    if("PDP" === lgkorUI.getHiddenInputData().pageGupun) {
                        categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
                    } else if(lgkorUI.getHiddenInputData().categoryId) {
                        categoryId = lgkorUI.getHiddenInputData().categoryId;
                    } else {
                        categoryId = searchCategoryId;
                    }
                }

                var storageCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, categoryId);
                var isCompare = vcui.isEmpty(storageCompare);
                var defaultCategoryCompare = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, lgkorUI.getHiddenInputData().categoryId);
                var isdefaultCategoryCompare = vcui.isEmpty(defaultCategoryCompare);

                var leng = isCompare ? 0 : storageCompare.data.length;
                if (leng) {
                    var limit = lgkorUI.getCompareLimit();
                    var isOpen = $('.right-cont .more-arrow').hasClass('open');
                    if (!isOpen) {
                        var height = _$('.KRP0015').outerHeight(true);
                        _$('.KRP0015').css({display: 'block', y: height});

                        if(load) {
                            closeCompareBox();
                            return false;
                        } else {
                            openCompareBox();
                        }
                    }

                    isInitChecked = true;
                } else {

                    var removeOption = $uiSelectbox.find('option').filter("[value=" + categoryId + "]");
                    var $uiSelectboxWrap = $('.sticy-compare .ui-selectbox-wrap'); // BTOCSITE-49304 [모니터링 G] 제품비교하기 초기화 후 다시 제품비교하기 시 카테고리 다르게 노출 됨

                    if (removeOption.length > 0) removeOption.remove();
                    if ($uiSelectbox.find('option').length === 1) {
                        $uiSelectbox.parent().remove();
                    } else if ($uiSelectbox.find('option').length === 0) { // BTOCSITE-49304 [모니터링 G] 제품비교하기 초기화 후 다시 제품비교하기 시 카테고리 다르게 노출 됨 START
                        $uiSelectboxWrap.parent().remove();
                    } // BTOCSITE-49304 [모니터링 G] 제품비교하기 초기화 후 다시 제품비교하기 시 카테고리 다르게 노출 됨 END

                    var removeForCompareCheck = function(){
                        if (isInitChecked) {
                            isInitChecked = false;
                            if (!self.willRemoveForCompare) {
                                if(getCompareStorageKeys.length == 0) {
                                    //addToastAlert();
                                }
                            } else {
                                self.willRemoveForCompare = false;
                            }
                        }
                    }

                    if(lgkorUI.getHiddenInputData().categoryId) {
                        // BTOCSITE-38770
                        if("PLP" === lgkorUI.getHiddenInputData().pageGupun) {
                            if (isdefaultCategoryCompare) {
                                hideCompareBox();
                            } else {
                                setCompares();
                            }
                        } else if("PDP" === lgkorUI.getHiddenInputData().pageGupun) {
                            if(lgkorUI.getHiddenInputData().defaultCategoryId === categoryId) {
                                hideCompareBox();
                            } else {
                                setCompares();
                            }
                        // BTOCSITE-89564 START
                        } else if (location && location.href && location.href.indexOf('wish-products') > -1) {
                            if (lgkorUI.getHiddenInputData().categoryId === categoryId) {
                                hideCompareBox();
                            } else {
                                closeCompareBox();
                                setCompares();
                            }
                        // BTOCSITE-89564 END
                        } else if (lgkorUI.getHiddenInputData().categoryId === categoryId) {
                            hideCompareBox();
                        } else {
                            setCompares();
                        }

                        removeForCompareCheck();
                    } else {
                        if(getCompareStorageKeys.length == 0) {
                            hideCompareBox();
                        } else {
                            setCompares(Object.keys(lgkorUI.getStorage(lgkorUI.COMPARE_KEY))[0]);
                        }

                        removeForCompareCheck();
                    }
                }
            }

            /**
             * 비교하기 레이어 노출
             */
            function showCompareBox(id) {
                //var isOpen = $('.right-cont .more-arrow').hasClass('open');
                var isOpen = _$('body').hasClass("open-compare");

                if (!isOpen) {
                    setCompares(id);
                    setCompareStatus(id, true);
                }
            }

            function openCompareBox() {
                $('.sticy-compare').addClass('is-active');
                _$('.KRP0015').addClass('is-active').prop('tabindex', 0).focus();
                $('.right-cont .more-arrow').removeClass('close').addClass('open');
                $('.right-cont .more-arrow').attr('aira-expanded', true);
                $('.right-cont .more-arrow span.blind').text('제품 비교하기 닫기');


                _$('.KRP0015').stop().transition({y: 0}, 200, "easeInOutCubic");
            }

            function closeCompareBox() {
                $('.sticy-compare').removeClass('is-active');
                _$('.KRP0015').removeClass('is-active').removeAttr('tabindex');
                $('.right-cont .more-arrow').removeClass('open').addClass('close');
                $('.right-cont .more-arrow').attr('aira-expanded', false);
                $('.right-cont .more-arrow span.blind').text('제품 비교하기 펼치기');

                var height = _$('.KRP0015').outerHeight(true) - $('.sticy-compare .compare-title').outerHeight(true);
                _$('.KRP0015').stop().transition({y: height}, 200, "easeInOutCubic");
                _$('body').addClass('open-compare');
            }

            function hideCompareBox() {
                $('.sticy-compare .list-inner li').removeClass("lge-only"); // BTOCSITE-62469 [선감지][모니터링 G] PLP 화면에서 비교하기 선택 시 닷컴ONLY 뱃지 미노출 되는 현상
                $('.sticy-compare').removeClass('is-active');
                _$('.KRP0015').removeClass('is-active');
                $('.right-cont .more-arrow').removeClass('open').addClass('close');
                $('.right-cont .more-arrow').attr('aira-expanded', false);
                $('.right-cont .more-arrow span.blind').text('제품 비교하기 펼치기');

                var height = _$('.KRP0015').outerHeight(true);
                _$('.KRP0015').stop().transition({y: height}, 350, "easeInOutCubic", function () {
                    _$('.KRP0015').css({display: 'none', y: 0});
                });
                _$('body').removeClass('open-compare');
            }

            function addToastAlert(mode) {
                var msg;
                if (mode == "excessive") {
                    msg = lgkorUI.getCompareLimit() + "개까지 비교가능합니다.";
                } else {
                    msg = "비교하기가 초기화 되었습니다.";  // BTOCSITE-89564
                }

                _$(window).trigger("toastshow", msg);
            }

            function setClearCompare() {
                var $uiSelectbox = $('.sticy-compare .ui_selectbox');
                var categoryId;

                if($uiSelectbox.length) {
                    categoryId = $uiSelectbox.vcSelectbox('value');
                } else {
                    // BTOCSITE-38770
                    if("PDP" === lgkorUI.getHiddenInputData().pageGupun) {
                        categoryId = lgkorUI.getHiddenInputData().defaultCategoryId;
                    } else if("PLP" === lgkorUI.getHiddenInputData().pageGupun) {
                        categoryId = Object.keys(lgkorUI.getStorage(lgkorUI.COMPARE_KEY))[0];
                    } else if(lgkorUI.getHiddenInputData().categoryId) {
                        categoryId = searchCategoryId;
                    }
                }

                if(lgkorUI.getHiddenInputData().categoryId || searchCategoryId) {
                    var removeOption ="";
                    if(lgkorUI.getHiddenInputData().categoryId){
                        removeOption = $uiSelectbox.find('option').filter("[value=" + categoryId + "]");
                    }else{
                        removeOption = $uiSelectbox.find('option').filter("[value=" + searchCategoryId + "]");
                    }

                    if (removeOption.length > 0) removeOption.remove();
                    if ($uiSelectbox.find('option').length === 1) {
                        //$('.sticy-compare').removeClass('cate-select');
                        $uiSelectbox.parent().remove();
                    }

                    lgkorUI.removeCompareProd(categoryId);
                } else {
                    $uiSelectbox.remove();
                    lgkorUI.removeStorage(lgkorUI.COMPARE_KEY);
                }

                addToastAlert();

            }

            function updateCompareButton() {
                var count = document.querySelectorAll('.compare-list .list-inner li>.item-inner').length;

                if (count > 1) {
                    $('.btn-compare').prop('disabled', false);
                } else {
                    $('.btn-compare').prop('disabled', true);
                }
            }

            function selectBoxTotalCount() {
                $('.sticy-compare .ui_selectbox option').each(function(){
                    var optionText = $(this).text();
                    var replaceTarget = window.innerWidth > 767 ? '/2' : '/3';
                    var replaceResult = window.innerWidth > 767 ? '/3' : '/3'; /* BTOCSITE-76675 비교하기 UI/UX 개선 */
                    var selectOpenElResult = optionText.replace(replaceTarget, replaceResult);

                    $(this).text(selectOpenElResult);
                });

                $('.sticy-compare .ui_selectbox').vcSelectbox('update');
            }

            /* [S] BTOCSITE-76675 비교하기 UI/UX 개선 */
            function updateCompareItemHeight() {
                var item = $('.sticy-compare .list-inner li');
                var maxHeight = 0;

                item.height('');

                if (!item.find('a').length) return;

                item.find('a').each(function() {
                    var $this = $(this);
                    var $thisH = $this.outerHeight();
                    maxHeight =  maxHeight < $thisH ? $thisH : maxHeight;
                });
                item.height(maxHeight);
            }
            /* [E] BTOCSITE-76675 비교하기 UI/UX 개선 */

            // BTOCSITE-3547 [컴포넌트오류]WCMS에서 KRC0025 컴포넌트 케러셀 적용 시 미리보기에서 하단으로 펼쳐짐오류
            if (location.host.indexOf('cms') === -1) {
                init();
            }
        })(
            function (selector) {
                return $('.KRP0015').find(selector);
            }, $
        );

        var isPurchasePage = ( $('.KRP0008').length > 0 ) ? true : false ; // 구매 페이지
        // 구매 페이지 아닐때
        if(!isPurchasePage){
            //비교하기 열기, 닫기시
            $('.KRP0015 .more-arrow').on('click',function(){
                setTimeout(function(){
                    $(window).trigger('scrollstart');
                },200)
            })
            //스크롤에 따라 앱하단바 네이티브 함수 호출
            $(window).on('scrollstart',function(){
                if($('.KRP0015').hasClass('is-active')){
                    lgkorUI.setEnableAppScrollBottomMenu(false);
                    lgkorUI.showAppBottomMenu(true);
                }else{
                    lgkorUI.setEnableAppScrollBottomMenu(true);
                }
            }).on('scrollend',function(){
                if($('.KRP0015').hasClass('is-active')){
                    lgkorUI.setEnableAppScrollBottomMenu(false);
                    lgkorUI.showAppBottomMenu(true);
                }else{
                    lgkorUI.setEnableAppScrollBottomMenu(true);
                }
            });
        }

        // BTOCSITE-20469 pc 마우스 오버/리브시 바닥 페이지 스크롤 제한
        $(function(){
            let compare_popup = $('.KRP0015');

            compare_popup.mouseenter(function(e){
                compare_popup.on('mousewheel', function(e){
                    e.preventDefault();
                });
            });

            compare_popup.mouseleave(function(e){
                compare_popup.on('mousewheel', function(e){
                    e.stopPropagation();
                });
            });
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'COMPARE', name: 'KRP0015-2.0.0', isFirstLoad: true, fn: function () {
                if (!document.querySelector('.KRP0015')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function () {
        SAVE_COMPONENT_PDP_DOM_MNG();

        if (!document.querySelector('.KRP0015')) return false;
        funcReady();
    });
})();
